var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferencesDarkmode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.422,
    height: 35.422,
    viewBox: "0 0 35.422 35.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-37.494 -253.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.711,35.422A17.711,17.711,0,1,0,0,17.711,17.711,17.711,0,0,0,17.711,35.422Zm0-3.542V3.542a14.169,14.169,0,1,1,0,28.338Z",
    transform: "translate(37.494 253.403)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesDarkmode);
export default __webpack_public_path__ + "static/media/preferences-darkmode.a184a6aeca1ee86e9e61d03440449607.svg";
export { ForwardRef as ReactComponent };